const getCmfApiUrl = (): string => (process.env.REACT_APP_USE_API_MOCK === 'true'
    ? process.env.REACT_APP_MOCK_API_URL as string
    : process.env.REACT_APP_LIVE_API_URL as string);

export default getCmfApiUrl;
